export const ITEMS_FETCH_SUCCESS = 'items/fetchSuccess';
export const FETCH_ITEMS = 'items/fetchItems'


export const CATEGORIES_FETCH_SUCCESS = 'categories/fetchSuccess';